/**
 * ゴミ箱の保持期間まわり。
 *
 * Supabase を参照する処理(→ trash.ts)とは分けてある。ここだけなら
 * ブラウザにも Node にも依存しないので、そのままテストできる。
 */

/**
 * 削除してから物理削除するまでの日数。
 * iOS 写真アプリの「最近削除した項目」と同じ 30 日に合わせ、
 * 「もう消えたはず」と思う時期がずれないようにする。
 */
export const RETENTION_DAYS = 30;

export const DAY_MS = 24 * 60 * 60 * 1000;

/** 物理削除される時刻。日時が読めなければ null */
export function purgeAt(deletedAt: string): Date | null {
  const deleted = new Date(deletedAt).getTime();
  if (Number.isNaN(deleted)) return null;
  return new Date(deleted + RETENTION_DAYS * DAY_MS);
}

/**
 * 物理削除までの残り日数。期限を過ぎていれば 0。
 *
 * 日時が読めないときは保持期間いっぱいを返す。取り消せない操作なので、
 * 判断に困ったら「まだ消さない」側に倒す。
 */
export function daysUntilPurge(deletedAt: string, now: Date = new Date()): number {
  const at = purgeAt(deletedAt);
  if (at === null) return RETENTION_DAYS;
  const remaining = at.getTime() - now.getTime();
  return remaining <= 0 ? 0 : Math.ceil(remaining / DAY_MS);
}

/** 配列を size ごとに切る */
export function chunk<T>(items: T[], size: number): T[][] {
  const chunks: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
}
